import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import * as URLs from '../../../../common/constants/systemUrls';
import { Affix, Button, Skeleton } from 'antd';
// компоненты контейнера
import CardForm from '../../components/vehicleCard/cardForm/CardForm';
// Actions
import * as getFieldsActions from '../../redux/actions/getFieldsActions';
import {
  archiveVehicle,
  restoreVehicle,
} from '../../redux/actions/updateVehicleActions';
import { interfaceActions } from '../../../../common/redux/actions';
import {
  getVehicleById,
  updateVehicle,
  createVehicle,
  clearErrors,
} from '../../redux/actions/vehicleCard';
// import { isEmptyObject } from '../../../../common/utils/configFormField';
// import history from '../../../../common/history';
import {
  // showConfirmPutArchive,
  // showConfirmRestorefromArchive,
  showConfirmAbortEdit,
  // showConfirmSaveEdit,
} from '../../components/common/modal/confirmModal/ConfirmModal';

// компоненты карты
import RightSide from '../../components/vehicleCard/rightSide/RightSide';

// Прогресс лист заполнения
//import ProgressList from '../../components/common/progressList/ProgressList';

import progresses from '../../components/common/FormProgress/progresses';
import FormProgress from '../../components/common/FormProgress/FormProgress';

// стили контейнера
import './vehicleCard.css';

let {
  getDriveTypes,
  getFacilitiesTypes,
  getInteriorsTypes,
  getAdvertisingsTypes,
  getTransfersTypes,
  getAppliancesTypes,
  getSeatMaterialsTypes,
  getModelsByBrand,
} = getFieldsActions;

const { setCaption } = interfaceActions;

class VehicleCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardDisabled: true,
      visible: false,
      // isArchive: false,
      showLoadVehicleModal: false,

      vehicleId: this.getVehicleId(),
      isEditable: false,
      formProgress: [...progresses.default],
    };

    if (this.state.vehicleId === 0) {
      this.state.isEditable = true;
    }
    this.forms = {};
  }

  componentDidMount() {
    this.setCaption(true);
    if (this.state.vehicleId > 0) {
      this.props.getVehicleById(this.state.vehicleId);
    }
    this.props.getFacilitiesTypes();
    this.props.getInteriorsTypes();
    this.props.getAdvertisingsTypes();
    this.props.getTransfersTypes();
    this.props.getAppliancesTypes();
    this.props.getSeatMaterialsTypes();
    this.props.clearErrors()
  }

  componentDidUpdate(prevProps, _prevState) {
    // const { vehicleById } = this.props;

    this.updateVehicleId(); // Смотрим не сменился ли VehicleId
    this.setCaption(
      this.props.vehicleById !== prevProps.vehicleById && this.props.vehicleById
    );

    // Закрывает редактирование после успешного обновления ТС
    if (
      this.state.isEditable &&
      this.props.updateSuccess !== prevProps.updateSuccess
    ) {
      this.handleClickClose();
    }
    /*
    if (prevProps.vehicleById !== vehicleById) {
      const { registerSignAndRegion } = vehicleById;
      const { modelName } = vehicleById.vehicleModelId;
      const { brandName } = vehicleById.vehicleModelId.vehicleBrandId;

      this.props.setCaption({
        enabled: true,
        mainCaption: `${modelName}, ${brandName} ${registerSignAndRegion}`,
        breadCrumbs: [
          // Путь для хлебных крошек
          {
            path: '/' + URLs.CONTROL_PANEL,
            breadcrumbName: 'Панель управления',
          },
          { path: '/' + URLs.VEHICLES, breadcrumbName: 'Каталог ТС' },
          {
            path: '/' + URLs.VEHICLE_CARD,
            breadcrumbName: `${modelName}, ${brandName} ${registerSignAndRegion}`,
          },
        ],
      });
    }
    */
  }

  setCaption(flagUpdate = false) {
    if (flagUpdate) {
      let title = '';
      let breadCrumbs = null;
      if (this.state.vehicleId === 0) {
        title = 'Добавление ТС';
      } else {
        const { vehicleById } = this.props;
        if (vehicleById) {
          const { registerSignAndRegion } = vehicleById;
          const { modelName } = vehicleById.vehicleModelId;
          const { brandName } = vehicleById.vehicleModelId.vehicleBrandId;
          title = `${modelName}, ${brandName} ${registerSignAndRegion}`;

          if (this.state.isEditable) {
            breadCrumbs = title;
            title = 'Редактирование ТС';
          }
        }
      }

      if (title) {
        this.props.setCaption({
          enabled: true,
          mainCaption: title,
          breadCrumbs: [
            {
              path: '/' + URLs.CONTROL_PANEL,
              breadcrumbName: 'Панель управления',
            },
            { path: '/' + URLs.VEHICLES, breadcrumbName: 'Каталог ТС' },
            {
              path: '/' + URLs.COMPANY,
              breadcrumbName: breadCrumbs ? breadCrumbs : title,
            },
          ],
        });
      }
    }
  }

  /*
  // редактирование поля
  setField = name => {
    this.setState(state => ({
      cardFields: { ...state.cardFields, ...name },
    }));
  };
*/

  //сохранить изменения и закончить редактировать
  handlerSaveChanges = () => {
    this.setState(() => ({
      cardDisabled: true,
    }));
  };

  // Вытаскиваем OrderId
  // todo если он равняется 'add' возвращаем 0 добавление нового заказа
  getVehicleId() {
    let { id = 0 } = this.props.match && this.props.match.params;
    id = Number(id);
    return id > 0 ? id : 0;
  }

  updateVehicleId() {
    const vehicleId = this.getVehicleId();
    if (vehicleId !== this.state.vehicleId) {
      if (vehicleId > 0) {
        this.props.getVehicleById(vehicleId);
      }
      this.setState(state => ({
        vehicleId,
        isEditable: vehicleId === 0 ? true : state.isEditable,
      }));
    }
  }

  handleClickClose = () => {
    this.setState(
      state => ({
        isEditable: false,
      }),
      () => {
        this.props.clearErrors()
        this.setCaption(true);
      }
    );
  };

  handleClickEdit = () => {
    this.setState(
      state => ({
        isEditable: true,
      }),
      () => {
        this.setCaption(true);
      }
    );
  };

  handleSubmit = () => {
    this.formSubmit('formVehicleInfo', fieldsValue => {
      const { vehicleId } = this.state;
      let data = {
        vehicleId,
        ...fieldsValue,
      };
      if (vehicleId === 0) {
        this.props.createVehicle(data);
      } else {
        this.props.updateVehicle(data);
      }
    });
  };

  /* todo то что можно вынести в общие компоненты */
  formSubmit = (name, cbSubmit) => {
    const form = this.getForm(name);
    if (form) {
      form.validateFields((err, fieldsValue) => {
        if (err) {
          return false;
        }
        // Отправка формы
        if (cbSubmit) cbSubmit(fieldsValue);
      });
    } else {
      console.log('Error', name);
    }
  };
  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };
  updateProgress = values => {
    const form = this.getForm('formVehicleInfo');
    if (form) {
      let newFormProgress = null;
      let checkAll = true;
      Object.keys(values).forEach(name => {
        this.state.formProgress.forEach((step, index) => {
          if (step.fields.some(fieldName => fieldName === name) && step.check) {
            const fieldsValue = form.getFieldsValue(step.fields);
            const check = step.check(fieldsValue, form);
            if (!newFormProgress)
              newFormProgress = [...this.state.formProgress];
            newFormProgress = [
              ...newFormProgress.slice(0, index),
              {
                ...newFormProgress[index],
                name: step.name,
                completed: check,
                fieldsValue: fieldsValue,
              },
              ...newFormProgress.slice(index + 1),
            ];
            if (checkAll && !check) {
              if (step.button !== false) checkAll = false;
            }
          }
        });
      });
      if (newFormProgress) {
        if (checkAll) {
          // Если все изменённые поля успешно прошли проверку
          // делаем полную проверку по всем группам
          // если button = false тогда он не участвует в проверке для кнопки отправки.
          // если в прогрессе нет ключа button то по умолчанию он равен true
          checkAll = newFormProgress.every(({ completed, button = true }) =>
            button ? completed : true
          );
        }
        this.setState({
          formProgress: newFormProgress,
        });
      }
    }
  };

  setFormFieldsAvtocod = data => {
    const form = this.getForm('formVehicleInfo');
    if (form) {
      // form.getFieldDecorator('engineCapacity'); // инициализируем поля, так как они изначально скрыты
      if (data) {
        form.setFields({
          brand: {
            value: data.brand ? data.brand : undefined,
            /* errors: !data.brand
              ? [
                  new Error(
                    `В базе нет бренда «${
                      data.brandName ? data.brandName : '—'
                    }»`
                  ),
                ]
              : null, */
          },
          model: {
            value: data.model ? data.model : undefined,
            /* errors: !data.model
              ? [
                  new Error(
                    `В базе нет модели «${
                      data.modelName ? data.modelName : '—'
                    }»`
                  ),
                ]
              : null, */
          },
          category: {
            value: data.category ? data.category : undefined,
            /* errors: !data.category
              ? [
                  new Error(
                    `В базе нет категории «${
                      data.categoryName ? data.categoryName : '—'
                    }»`
                  ),
                ]
              : null, */
          },
          color: {
            value: data.color ? data.color : undefined,
            /* errors: !data.color
              ? [
                  new Error(
                    `В базе нет цвета «${
                      data.colorName ? data.colorName : '—'
                    }»`
                  ),
                ]
              : null,*/
          },
          vehicleType: {
            value: data.vehicleType ? data.vehicleType : undefined,
            /* errors: !data.vehicleType
              ? [
                  new Error(
                    `В базе нет типа ТС «${
                      data.vehicleTypeName ? data.vehicleTypeName : '—'
                    }»`
                  ),
                ]
              : null,*/
          },
          productionYear: {
            value: data.productionYear ? data.productionYear : undefined,
            errors: null,
          },
          engineTypeName: {
            value: data.engineTypeName ? data.engineTypeName : undefined,
            errors: null,
          },
          engineVolume: {
            value: data.engineVolume ? data.engineVolume : undefined,
            errors: null,
          },
          engineCapacity: {
            value: data.engineCapacity ? data.engineCapacity : undefined,
            errors: null,
          },
          vehicleWeight: {
            value: data.vehicleWeight ? data.vehicleWeight : undefined,
            errors: null,
          },
          vehicleMaxWeight: {
            value: data.vehicleMaxWeight ? data.vehicleMaxWeight : undefined,
            errors: null,
          },
          steeringArrangement: {
            value: data.steeringArrangement
              ? data.steeringArrangement
              : undefined,
            errors: null,
          },
        });
        /*
        form.setFieldsValue({
          vehicleMaxWeight: data.vehicleMaxWeight,
          steeringArrangement: data.steeringArrangement,
        });
        */
      }
    }
  };

  /* end */

  render() {
    const {
      // cardFields,
      // isArchive,
      isEditable,
    } = this.state;
    const { vehicleById, autoSearchStatus, isLoading, activeProfile, isFetching } = this.props;
    const typeForm =
      this.state.vehicleId > 0 ? (isEditable ? 'edit' : 'view') : 'create';
    // todo Переверстать полностью страницу
    return (
      <Fragment>
        {/* {(!vehicleById && (
          <div className="basicForm thereIsSpinner">
            <Spin tip="Loading..." size="large" />
          </div>
        )) || ( */}
        {isLoading ? (
          <div className="site-wrapper offer-card">
            <div
              style={{
                marginTop: 16,
                backgroundColor: '#fff',
                padding: 32,
                maxWidth: 848,
              }}
            >
              <Skeleton active />
            </div>
          </div>
        ) : (
            <div className="vehicleCardWrapper basicForm">
              <CardForm
                {...this.props}
                vehicle={vehicleById}
                resetCardValues={() => this.setState({ cardFields: {} })}
                vehicleId={this.state.vehicleId}
                updateProgress={this.updateProgress}
                isEditable={isEditable}
                name="formVehicleInfo"
                setForm={this.setForm}
                typeForm={typeForm}
                setFormFieldsAvtocod={this.setFormFieldsAvtocod}
                autoSearchStatus={autoSearchStatus}
              />
              {(isEditable && (
                <Fragment>
                  <Affix
                    target={() => document.getElementById('mainSheet')}
                    offsetTop={16}
                  >
                    <div className="order-card__sidebar">
                      <div className="orderCard__btn-submit">
                        <Button
                          // loading={addingStatus === 'loading'}
                          loading={isFetching}
                          className="addVehicleBtn"
                          type="primary"
                          size="large"
                          onClick={this.handleSubmit}
                        >
                          {isFetching ? '' : 'Сохранить'}
                        </Button>
                      </div>
                      <div className="offer-card__progress">
                        <FormProgress progress={this.state.formProgress} />
                      </div>
                      <div className="offer-card__btn-close" style={{marginTop: 16}}>
                        <Button
                          className="btn_danger-close"
                          type="danger"
                          ghost
                          size="large"

                          onClick={() =>
                            showConfirmAbortEdit({
                              onOk: () => {
                                if (this.getVehicleId() !== 0) {
                                  this.handleClickClose()
                                } else {
                                  // Если отменяем добавление нового ТС то выкидывает обратно к списку ТС
                                  this.props.history.push(`/vehicles/`)
                                }
                              }
                            })
                          }
                        >
                          Отмена
                      </Button>
                      </div>
                    </div>
                  </Affix>
                </Fragment>
              )) || (
                  <RightSide
                    getVehicle={getVehicleById}
                    fields={vehicleById}
                    isArchive={
                      vehicleById && vehicleById.vehicleStatusKey === 'archive'
                    }
                    activeProfile={activeProfile}
                    //archiveVehicle={archiveVehicle}
                    //restoreVehicle={restoreVehicle}
                    //archivingStatus={archivingStatus}
                    //archivingError={archivingError}
                    //restoringStatus={restoringStatus}
                    //restoringError={restoringError}
                    // редактирование Карточки
                    handlerEditVehicle={this.handleClickEdit}
                    // загрузка ТС
                    vehicleId={this.state.vehicleId}
                    loadVehicleHandler={() => console.log('going to load vehicle')}
                  />
                )}
            </div>
          )}
        {/* )} */}
      </Fragment>
    );
  }
}

export default connect(
  state => ({
    vehicleById: state.Transport.VehicleCard.data,
    isLoading: state.Transport.VehicleCard.isLoading,
    isFetching: state.Transport.VehicleCard.isFetching,
    updateSuccess: state.Transport.VehicleCard.success,
    // fields data
    driveTypes: state.Transport.Fields.driveTypes,
    facilitiesTypes: state.Transport.Fields.facilitiesTypes,
    interiorsTypes: state.Transport.Fields.interiorsTypes,
    transfersTypes: state.Transport.Fields.transfersTypes,
    advertisingsTypes: state.Transport.Fields.advertisingsTypes,
    seatMaterialsTypes: state.Transport.Fields.seatMaterialsTypes,
    appliancesTypes: state.Transport.Fields.appliancesTypes,
    activeProfile: state.Authorization.activeProfile,
    autoSearchStatus:
      state.Transport.AddVehicle.autoSearch &&
      state.Transport.AddVehicle.autoSearch.status,
    // CRUD data
    //updating Vehicle status
    // updatingStatus: state.Transport.VehicleCard.updatingVehicleStatus.Status,
    // updatingError:
    //  state.Transport.VehicleCard.updatingVehicleStatus.updatingError,
    // archiving STATUSES
    // archivingStatus:
    //  state.Transport.VehicleCard.vehicleStatus.archivingVehicleStatus.Status,
    //archivingError:
    //  state.Transport.VehicleCard.vehicleStatus.archivingVehicleStatus.Error,
    //restoringStatus:
    //  state.Transport.VehicleCard.vehicleStatus.restoringVehicleStatus.Status,
    //restoringError:
    //  state.Transport.VehicleCard.vehicleStatus.restoringVehicleStatus.Error,
  }),
  {
    setCaption,
    // CRUD METHODS
    getVehicleById,
    updateVehicle,
    createVehicle,
    archiveVehicle,
    restoreVehicle,
    clearErrors,
    // GET FIELDS METHODS
    getDriveTypes,
    getFacilitiesTypes,
    getInteriorsTypes,
    getAdvertisingsTypes,
    getTransfersTypes,
    getAppliancesTypes,
    getSeatMaterialsTypes,
    getModelsByBrand,
  }
)(VehicleCard);
